var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0014 17.6171V20.6171C22.0025 20.8956 21.9455 21.1713 21.8339 21.4265C21.7223 21.6816 21.5587 21.9107 21.3535 22.099C21.1483 22.2873 20.906 22.4306 20.6421 22.5198C20.3783 22.609 20.0988 22.6422 19.8214 22.6171C16.7442 22.2828 13.7884 21.2313 11.1914 19.5471C8.77523 18.0118 6.72673 15.9633 5.1914 13.5471C3.50138 10.9383 2.44964 7.96811 2.1214 4.87712C2.09641 4.60059 2.12927 4.32188 2.2179 4.05874C2.30652 3.79561 2.44897 3.55381 2.63616 3.34874C2.82336 3.14367 3.0512 2.97983 3.30519 2.86764C3.55917 2.75545 3.83374 2.69738 4.1114 2.69712H7.1114C7.5967 2.69234 8.06719 2.8642 8.43516 3.18065C8.80313 3.49711 9.04348 3.93657 9.1114 4.41712C9.23802 5.37718 9.47285 6.31985 9.8114 7.22712C9.94594 7.58504 9.97506 7.97403 9.8953 8.348C9.81555 8.72196 9.63026 9.06523 9.3614 9.33712L8.0914 10.6071C9.51495 13.1107 11.5879 15.1836 14.0914 16.6071L15.3614 15.3371C15.6333 15.0683 15.9766 14.883 16.3505 14.8032C16.7245 14.7235 17.1135 14.7526 17.4714 14.8871C18.3787 15.2257 19.3213 15.4605 20.2814 15.5871C20.7672 15.6556 21.2108 15.9003 21.5279 16.2746C21.8451 16.6489 22.0136 17.1267 22.0014 17.6171Z",
    stroke: "#FBE5D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.48276914a4e02db3e1f30c64efb99168.svg";
export { ForwardRef as ReactComponent };